import { Col, Row } from 'antd';
import { t } from 'i18next';
import { observer } from 'mobx-react-lite';
import { Card } from 'src/components/Card/Card';
import { DataView } from 'src/components/DataView/DataView';
import { LoanApplicationDto } from 'src/generated-api-client';
import { CommissionType } from 'src/stores/LoanApplicationsStore/LoanApplicationsStore.types';

type LoanApplicationPartnerInfoProps = {
    application?: LoanApplicationDto;
};

export const LoanApplicationPartnerInfo = observer(
    ({ application }: LoanApplicationPartnerInfoProps) => {
        if (!application?.assignedPartner) {
            return null;
        }

        return (
            <Card title={t('LoanApplication.PartnerInfo.Title')}>
                <Row gutter={[16, 16]}>
                    <Col xs={24} sm={12} md={12}>
                        <DataView
                            label={t(
                                'LoanApplication.PartnerInfo.AssignedPartner',
                            )}
                            value={
                                application.assignedPartner?.arabicName ||
                                application.assignedPartner.englishName
                            }
                        />
                    </Col>
                    <Col xs={24} sm={12} md={12}>
                        <DataView
                            label={t('LoanApplication.PartnerInfo.AssignedAt')}
                            value={undefined}
                            formatValue="dateTimeSeconds"
                        />
                    </Col>
                    <Col xs={24} sm={12} md={12}>
                        <DataView
                            label={t('LoanApplication.PartnerInfo.ProductID')}
                            value={application.product?.number}
                        />
                    </Col>
                    <Col xs={24} sm={12} md={12}>
                        <DataView
                            label={t('LoanApplication.PartnerInfo.ProductName')}
                            value={application.product?.name}
                        />
                    </Col>
                    <Col xs={24} sm={12} md={12}>
                        <DataView
                            label={t(
                                'LoanApplication.PartnerInfo.JahezCommission',
                            )}
                            value={
                                application.assignedPartner
                                    .jahezComissionType ===
                                CommissionType.PERCENTAGE
                                    ? application.assignedPartner
                                          .jahezComissionPct
                                    : application.assignedPartner
                                          .jahezComissionAmount
                            }
                            formatValue={
                                application.assignedPartner
                                    .jahezComissionType ===
                                CommissionType.PERCENTAGE
                                    ? 'percent'
                                    : 'currency-sar'
                            }
                        />
                    </Col>

                    <Col xs={24} sm={12} md={12}>
                        <DataView
                            label={t(
                                'LoanApplication.PartnerInfo.PartnerSystemLink',
                            )}
                            value={application.product?.partnerSystemLink}
                        />
                    </Col>
                </Row>
            </Card>
        );
    },
);
